import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/** ローディング表示 */
const progressModule = {
  namespaced: true,
  state: {
    loading: false
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    }
  }
}

/** モダール表示 */
const infoModalModule = {
  namespaced: true,
  state: {
    open: false,
    type: '',
    title: '',
    message: '',
    btnLabel: '閉じる',
    callback: function () { }
  },
  mutations: {
    openModal (state, option) {
      state.open = true
      state.type = option.type
      state.title = option.title
      state.message = option.message
      state.btnLabel = option.btnLabel || '閉じる'
      state.callback = option.callback || function () { }
    },
    closeModal (state) {
      state.open = false
    }
  }
}

/** 確認モダール表示 */
const confirmModalModule = {
  namespaced: true,
  state: {
    open: false,
    title: '',
    message: '',
    executeLabel: '実行',
    cancelLabel: 'キャンセル',
    callback: function () { }
  },
  mutations: {
    openModal (state, option) {
      state.open = true
      state.type = option.type
      state.title = option.title
      state.message = option.message
      state.executeLabel = option.executeLabel || '実行'
      state.cancelLabel = option.cancelLabel || 'キャンセル'
      state.callback = option.callback || function () { }
    },
    closeModal (state) {
      state.open = false
    }
  }
}

/** 受け取り側画面用データ */
const receiverModule = {
  namespaced: true,
  state: {
    files: null,
    username: '',
    title: '-',
    expireDate: '',
    uploadedDate: '',
    comments: '-'
  },
  mutations: {
    setExchange (state, exchange) {
      state.files = exchange.download_urls
      state.title = exchange.title || '-'
      state.expireDate = exchange.expire_date
      state.uploadedDate = exchange.uploaded_date
      state.comments = exchange.comments || '-'
    },
    setUserName (state, username) {
      state.username = username
    },
    clear (state) {
      state.files = null
      state.username = ''
      state.title = '-'
      state.expireDate = ''
      state.uploadedDate = ''
      state.comments = '-'
    }
  }
}

export const defaultModules = {
  progress: progressModule,
  infoModal: infoModalModule,
  receiver: receiverModule,
  confirmModal: confirmModalModule
}

export default new Vuex.Store({
  modules: defaultModules
})
